import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ComViewAssetClassesDialogGridLayoutService } from './com-view-asset-classes-dialog.component.grid-layout.service';
import { SecurityMasterAssetCategoryService } from '@irb/irb-models/security-master/security-master.asset-category.service';
import { ISecurityMasterAssetClass } from '@irb/irb-models/irb-models.model';

@Component({ standalone: false,
  selector: 'irb-com-view-asset-classes-dialog',
  templateUrl: './com-view-asset-classes-dialog.component.html',
  styleUrl: './com-view-asset-classes-dialog.component.scss'
})
export class ComViewAssetClassesDialogComponent {
  gridOptions: any;
  grid: any;
  frameworkComponents: any;
  data: Array<ISecurityMasterAssetClass>;
  isUiTest: boolean = false;

  constructor(public dialogRef: MatDialogRef<ComViewAssetClassesDialogComponent>,
    private smac: SecurityMasterAssetCategoryService,
    private gls: ComViewAssetClassesDialogGridLayoutService,
      @Inject(MAT_DIALOG_DATA) public mdd: any
    ) {
      this.gridOptions = {
        columnDefs: this.gls.getColumnDefs(this),      
        floatingFilter: false,
        overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No Rows.</span>",
        context: { componentParent: this },
        suppressHorizontalScroll: true,
        treeData: true,
        treeDataDisplayType: 'custom',
        getDataPath: (data: ISecurityMasterAssetClass) => data.path
      };
      
      this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  onGridReady(params: any) {
    this.grid = params;
    this.smac.getAllAssetClasses((data: Array<ISecurityMasterAssetClass>) => {
      data.forEach((r: ISecurityMasterAssetClass) => {
        r.path = [];
        let s = r.code.toString();
        
        for(let i = 0; i <= 6; i += 2) {
          let c = s.substring(i,i + 2); 

          if(c.length > 0) {
            r.path.push(c);
          } else {
            break;
          }
        }
      });

      this.data = data;
    });
  }

  close() {
    this.dialogRef.close();
  }

  expandAll() {
      this.grid?.api.expandAll();
  }

  collapseAll() {
      this.grid?.api.collapseAll();
  }
}
